import { lazy, Suspense, useEffect, useState } from "react";
import { isWebpSupported } from "react-image-webp/dist/utils";
import { FormattedMessage } from "react-intl";
import alderneyLogoSVG from "../../../../images/logos/agcc-svg.svg";
import "./PublicHero.scss";
const PublicLayoutContainer = lazy(
  () => import("../../layouts/PublicLayoutContainer/PublicLayoutContainer")
);

const PublicHero = (): React.JSX.Element => {
  const [webpSupported, setWebpSupported] = useState(false);

  useEffect(() => {
    setWebpSupported(isWebpSupported());
  }, []);

  return (
    <div className="public-hero">
      <div
        className={`${
          webpSupported ? "public-hero__image__webp" : "public-hero__image"
        }`}
      />
      <Suspense fallback={<div className="fallback">loading...</div>}>
        <PublicLayoutContainer>
          <div className="public-hero__text-box">
            <h1 className="public-hero__title grotesk-font">
              <FormattedMessage tagName="span" id="home-hero-title" />
            </h1>
            <h2 className="public-hero__sub-title grotesk-font">
              <FormattedMessage tagName="span" id="home-hero-subtitle" />
            </h2>
            <a
              target="_blank"
              href="https://www.gamblingcontrol.org/licensees/egambling-licensees"
              rel="noopener noreferrer"
            >
              <img
                className="public-hero__logo"
                alt="Alderney Logo"
                src={alderneyLogoSVG}
                width={162}
                height={32}
              />
            </a>
          </div>
        </PublicLayoutContainer>
      </Suspense>
    </div>
  );
};

export default PublicHero;
